import React from 'react';

export const MathNumber = function () {
    const name = "math_number";
    MathNumber.blockName = name;

    return (
        <block type={name}>
            <field name="NUM">123</field>
        </block>
    );
};

export const MathArithmetic = function () {
    const name = "math_arithmetic";
    MathArithmetic.blockName = name;

    return (
        <block type={name}>
            <value name="A">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="B">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathSingle = function () {
    const name = "math_single";
    MathSingle.blockName = name;

    return (
        <block type={name}>
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">9</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathTrig = function () {
    const name = "math_trig";
    MathTrig.blockName = name;

    return (
        <block type={name}>
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">45</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathConstant = function () {
    const name = "math_constant";
    MathConstant.blockName = name;

    return (
        <block type={name}></block>
    );
};

export const MathNumberProperty = function () {
    const name = "math_number_property";
    MathNumberProperty.blockName = name;

    return (
        <block type={name}>
            <value name="NUMBER_TO_CHECK">
                <shadow type="math_number">
                    <field name="NUM">0</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathRound = function () {
    const name = "math_round";
    MathRound.blockName = name;

    return (
        <block type={name}>
            <value name="NUM">
                <shadow type="math_number">
                    <field name="NUM">3.1</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathOnList = function () {
    const name = "math_on_list";
    MathOnList.blockName = name;

    return (
        <block type={name}></block>
    );
};

export const MathModulo = function () {
    const name = "math_modulo";
    MathModulo.blockName = name;

    return (
        <block type={name}>
            <value name="DIVIDEND">
                <shadow type="math_number">
                    <field name="NUM">64</field>
                </shadow>
            </value>
            <value name="DIVISOR">
                <shadow type="math_number">
                    <field name="NUM">10</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathConstrain = function () {
    const name = "math_constrain";
    MathConstrain.blockName = name;

    return (
        <block type={name}>
            <value name="VALUE">
                <shadow type="math_number">
                    <field name="NUM">50</field>
                </shadow>
            </value>
            <value name="LOW">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="HIGH">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathRandomInt = function () {
    const name = "math_random_int";
    MathRandomInt.blockName = name;

    return (
        <block type={name}>
            <value name="FROM">
                <shadow type="math_number">
                    <field name="NUM">1</field>
                </shadow>
            </value>
            <value name="TO">
                <shadow type="math_number">
                    <field name="NUM">100</field>
                </shadow>
            </value>
        </block>
    );
};

export const MathRandomFloat = function () {
    const name = "math_random_float";
    MathRandomFloat.blockName = name;

    return (
        <block type={name}></block>
    );
};
